module.exports = __webpack_public_path__ + "assets/more_horiz.f6531b83.svg";